import CommonApi from '../commonApi';
const overhaulType = new CommonApi('overhaulType', 'Виды работ по капитальному ремонту ТС');
export default {
  ...overhaulType
};
